<div class="emma-json-editor">
    <emma-textarea
        [ngModel]="jsonPretty"
        (ngModelChange)="onChange($event)"
        [autocompleteItems]="autocompleteItems"
        [autocompleteButtonLabel]="autocompleteButtonLabel"
        [autocompleteNotFound]="autocompleteNotFound"
        [useMonospaceFont]="true"
        [linesToShow]="linesToShow"
        [readonly]="readonly"
        [disabled]="disabled"
        (blur)="onTouch()"
        (focus)="onTouch()"
    >
        <ng-template *ngIf="autocompleteItems?.length" emma-textarea-highlight-tpl
            ><div [innerHtml]="jsonPrettyHighlighted"></div
        ></ng-template>
        <ng-template emma-textarea-footer-tpl>
            <button
                *ngIf="!readonly && !disabled && validateJson && formatJson"
                emmaButton
                color="metal"
                [disabled]="!jsonPretty || isInvalid"
                (click)="doFormatJson()"
                i18n
            >
                Formatear JSON
            </button>
        </ng-template>
    </emma-textarea>
</div>
